import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  const format = number ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  if (number === null || number === undefined || isNaN(number)) return '';

  const abs = Math.abs(number);
  let value = number;
  let suffix = '';

  if (abs >= 1_000_000_000_000) {
    value = number / 1_000_000_000_000;
    suffix = ' Triliun'; // triliun
  } else if (abs >= 1_000_000_000) {
    value = number / 1_000_000_000;
    suffix = ' Milyar'; // milyar
  } else if (abs >= 1_000_000) {
    value = number / 1_000_000;
    suffix = ' Juta'; // juta
  } else if (abs >= 1_000) {
    value = number / 1_000;
    suffix = ' Ribu'; // ribu
  }

  // Hilangkan .00 jika bilangan bulat
  const formatted = Number.isInteger(value) ? value.toFixed(0) : value.toFixed(1);

  return `${formatted}${suffix}`;
}

export function fMoreShortenNumber(number) {
  if (number === null || number === undefined) return '';

  // Pastikan value berupa angka
  const num = typeof number === 'number' ? number : Number(number);
  if (isNaN(num)) return '';

  const abs = Math.abs(num);
  let value = num;
  let suffix = '';

  if (abs >= 1_000_000_000_000) {
    value = num / 1_000_000_000_000;
    suffix = ' T'; // triliun
  } else if (abs >= 1_000_000_000) {
    value = num / 1_000_000_000;
    suffix = ' M'; // milyar
  } else if (abs >= 1_000_000) {
    value = num / 1_000_000;
    suffix = ' Jt'; // juta
  } else if (abs >= 1_000) {
    value = num / 1_000;
    suffix = ' Rb'; // ribu
  }

  // Jika hasilnya bukan angka valid (misal undefined karena pembagian dengan NaN)
  if (isNaN(value)) return '0';

  // Hilangkan .00 jika bilangan bulat
  const formatted = Number.isInteger(value)
    ? value.toFixed(0)
    : value.toFixed(1);

  return `${formatted}${suffix}`;
}


export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

export function fCurrencyIndo(value) {
  if (value == null || isNaN(value)) return 'Rp 0';
  return 'Rp ' + numeral(value).format('0,0').replace(/,/g, '.');
}


function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
